import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  color: PropTypes.string
};

const getLogoAsset = (color) => {
  if (color === 'white') {
    return '/static/vrack-logo-white.svg';
  }
  return '/static/vrack-logo.svg';
};

export default function Logo({ sx, color }) {
  const theme = useTheme();
  // Use the white logo when explicitly requested OR when in dark mode (unless explicitly set to default)
  const resolvedColor = color || (theme.palette.mode === 'dark' ? 'white' : 'default');

  return (
    <Box
      component="img"
      src={getLogoAsset(resolvedColor)}
      sx={{ width: '100%', height: 50, ...sx }}
    />
  );
}
